import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import SmartSendPricing from '~/routes/smartsend/postage-rates';
import PickAndPacking from '~/routes/smartsend/pick-and-packing';
import CsvMappings from '~/routes/smartsend/csv-mappings';
import { SettingsCache } from '~/lib/consts/settings-cache';

export const childrenOfTools = [
  {
    path: RoutingConstants.PickAndPacking,
    element: <PickAndPacking />
  },
  {
    path: RoutingConstants.Pricing,
    element: <SmartSendPricing />
  },
  {
    path: RoutingConstants.CsvMapping,
    element: <CsvMappings />
  }
];

export const routesOfTools = childrenOfTools.map((r) => r.path);

export const sanitisedRoutesOfTools = () =>
  routesOfTools.filter((x) => {
    switch (x) {
      case RoutingConstants.CsvMapping:
        return SettingsCache.settings.Features.includes('CsvMapping');

      case RoutingConstants.PickAndPacking:
        return SettingsCache.settings.Features.includes('PackageContents');

      case RoutingConstants.Pricing:
        return (
          SettingsCache.settings.Features.includes('Prices') &&
          !SettingsCache.settings.Features.includes('RatesSidepanel')
        );

      default:
        return true;
    }
  });
